module.exports = __webpack_public_path__ + "static/assets/fa4cf8aa890d0d1bcff50b8d785c738c.png";